// Bridge a project PDF (an uploaded file or the agent-generated solution PDF)
// into the standalone Study flow. Fetch the presigned PDF → upload it to the
// server-backed Study library (so it opens on any device) → warm the local
// IndexedDB blob cache under the new docId → the Study page renders it in
// <PdfMarkingWorkspace>. Returns the server docId; the caller navigates to
// /app/study/{docId}.
import { savePdfAs } from "@/create/lecture/lecture-pdf-store";
import { extractPdfText } from "@/create/lecture/extract-pdf-text";
import { uploadStudyDocument } from "@/api/study";

export async function openPdfInStudy(url: string, name: string): Promise<string> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Could not fetch the PDF (${res.status}).`);
  const blob = await res.blob();
  const filename = name.replace(/\.pdf$/i, "") || "Project PDF";
  const file = new File([blob], `${filename}.pdf`, { type: "application/pdf" });
  let extractedText = "";
  try {
    extractedText = await extractPdfText(file);
  } catch {
    /* scanned / no extractable text — snips still drive marking */
  }
  const doc = await uploadStudyDocument({ file, filename, extractedText });
  // Warm the local blob cache so the Study page renders without re-downloading.
  try {
    await savePdfAs(doc.id, blob);
  } catch {
    /* cache is best-effort — the page falls back to the presigned pdf_url */
  }
  return doc.id;
}
